export enum PERSON_TYPE_ENUM {
  NATURAL = 'cpf',
  JURIDICAL = 'cnpj',
}
